export default {
  postsFilesClicks: (state) => state.postsFilesClicks
};
